import React, { useEffect, useState } from 'react';
import Terms from '../views/company/auth/Terms';
import {
  Dialog,
  DialogContent,
  IconButton,
  Button,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import JobQuickCreateModal from './JobQuickCreateModal';
import ServerURL from '../serverURL';

const AgentApprovalPendingModal = ({
  open,
  onClose,
  onComplete,
  companyRegistered,
  jobPublished,
}) => {
  const [quickCreateOpen, setQuickCreateOpen] = useState(false);
  const [quickJobId, setQuickJobId] = useState('');
  const [quickJobTitle, setQuickJobTitle] = useState('');
  const [termsOpen, setTermsOpen] = useState(false);

  // If both are completed, immediately complete flow
  useEffect(() => {
    if (open && companyRegistered && jobPublished) {
      onComplete && onComplete();
    }
  }, [open, companyRegistered, jobPublished, onComplete]);

  const handleClose = () => {
    localStorage.removeItem('first_login');
    onClose && onClose();
  };

  const handleQuickCreateOpen = () => setQuickCreateOpen(true);
  const handleQuickCreateClose = () => setQuickCreateOpen(false);
  const handleOpenTerms = () => setTermsOpen(true);
  const handleCloseTerms = () => setTermsOpen(false);

  if (!open) return null;

  const showTwoCards = !companyRegistered || !jobPublished;
  const isBothMissing = !companyRegistered && !jobPublished;

  const companyButtonLabel = '申請中​';
  const companyButtonDisabled = false;
  const jobButtonDisabled = true;
  const jobButtonLabel = isBothMissing
    ? '登録する'
    : jobPublished
    ? '登録済'
    : '登録にすすむ';

  const fetchJobs = (status, page, rowsPerPage, query, order, orderBy) => {
    console.log('Fetching jobs with status:', status);
  };

  const JobActiveStatus = 'active';
  const page = 0;
  const rowsPerPage = 10;
  const searchQuery = '';
  const order = 'asc';
  const orderBy = 'jobTitle';

  return (
    <>
      {/* ─── Main Modal ─── */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="scout-prereq-dialog"
        scroll="body"
        PaperProps={{
          sx: {
            width: 520,
            p: 0,
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: 'center',
            position: 'relative',
            backgroundColor: 'transparent',
            overflow: 'visible',
            maxHeight: 'none',
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            sx={{
              fontFamily: '"Noto Sans JP", sans-serif',
              fontSize: 19,
              fontWeight: 700,
              color: '#000',
              mt: 3,
            }}
          >
            本契約へ切り替えるとスカウトが開始できます
          </Typography>

          {showTwoCards ? (
            <div
              style={{
                marginTop: 16,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                alignItems: 'center',
              }}
            >
              {/* ─── 会社情報カード ─── */}
              <div
                style={{
                  borderRadius: 12,
                  padding: '14px 18px',
                  width: 410,
                  backgroundColor: '#ffce5259',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: 15,
                          fontFamily: '"Noto Sans JP", sans-serif',
                          textAlign: 'left',
                        }}
                      >
                        本契約への切替
                      </Typography>
                    </div>
                    <Typography
                      sx={{
                        fontSize: 14,
                        mt: 0.5,
                        color: '#000000ff',
                        fontFamily: '"Noto Sans JP", sans-serif',
                        textAlign: 'left',
                      }}
                    >
                      求職者に公開する会社情報等
                    </Typography>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div />
                    <div>
                      <Button
                        variant="contained"
                        disabled={companyButtonDisabled}
                        onClick={() => {
                          return; // 申請中のため、クリックしても何もしない
                        }}
                        sx={{
                          width: 120,
                          backgroundColor: '#a12626 !important',
                          color: '#ffffff !important',
                          boxShadow: 'none',
                          fontFamily: '"Noto Sans JP", sans-serif',
                          '&:hover': {
                            backgroundColor: '#a12626 !important',
                            cursor: 'default',
                          },
                        }}
                      >
                        {companyButtonLabel}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', mt: 1, mb: 1, ml:-5 }}>
                <Button
                  variant="outlined"
                  sx={{
                    backgroundColor: "#3f79b8",   // blue like screenshot
                    color: "#fff",
                    fontFamily: '"Noto Sans JP", sans-serif',
                    fontSize: "10px",
                    lineHeight: 1.15,
                    px: 1.2,                     // horizontal padding
                    py: 0.6,                     // vertical padding
                    minWidth: 90,
                    borderRadius: "2px",
                    boxShadow: "none",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#3f79b8",
                      boxShadow: "none",
                    },
                  }}
                  onClick={handleOpenTerms}
                >
                  利用規約
                  <br />
                  プライバシーポリシー
                </Button>
              </Box>

              {/* ─── 求人情報カード ─── */}
              <div
                style={{
                  borderRadius: 12,
                  padding: '14px 18px',
                  width: 410,
                  background: '#ffce5259',
                  marginBottom: 24,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: 15,
                        fontFamily: '"Noto Sans JP", sans-serif',
                        textAlign: 'left',
                      }}
                    >
                      求人掲載
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 14,
                        mt: 0.5,
                        color: '#000000',
                        fontFamily: '"Noto Sans JP", sans-serif',
                        textAlign: 'left',
                      }}
                    >
                      求職者に公開する仕事情報
                    </Typography>
                  </div>
                  <div>
                    <Button
                      variant="contained"
                      className="LightBlueButton"
                      disabled={jobButtonDisabled}
                      onClick={() => {
                        if (jobButtonDisabled) return;
                        handleQuickCreateOpen();
                      }}
                      sx={{
                        boxShadow: 'none',
                        borderColor: '#046EB8',
                        color: '#046EB8',
                        width: 120,
                      }}
                    >
                      {jobButtonLabel}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Typography
              sx={{
                fontFamily: '"Noto Sans JP", sans-serif',
                color: '#000',
                fontSize: 14,
                textAlign: 'center',
                marginTop: '8px',
              }}
            >
              全ての情報が登録済みです。
            </Typography>
          )}
        </DialogContent>
      </Dialog>

      {/* ─── Job Quick Create Modal ─── */}
      <JobQuickCreateModal
        open={quickCreateOpen}
        onClose={handleQuickCreateClose}
        jobUniqueCode={quickJobId}
        setJobUniqueCode={setQuickJobId}
        jobTitle={quickJobTitle}
        setJobTitle={setQuickJobTitle}
        onJobCreated={() =>
          fetchJobs(JobActiveStatus, page + 1, rowsPerPage, searchQuery, order, orderBy)
        }
      />

      {/* ─── Terms Modal ─── */}
      <Dialog
        open={termsOpen}
        onClose={handleCloseTerms}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            width: '90vw',
            height: '95vh',
            maxWidth: '90vw',
            maxHeight: '95vh',
            m: 0,
          },
        }}
      >
        <DialogContent sx={{ p: 0, height: '100%', position: 'relative', overflowY: 'auto' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              pt: 2,
              pr: 2,
              position: 'sticky',
              top: 0,
              zIndex: 20,
              background: 'rgba(255,255,255,0.97)',
              borderBottom: '1px solid #eee',
            }}
          >
            <Button
              variant="outlined"
              size="small"
              sx={{ mr: 1, fontFamily: '"Noto Sans JP", sans-serif' }}
              onClick={async () => {
                try {
                  const apiUrl = `${ServerURL.PRODUCTION_HOST_URL}companies/download_privacy_policy_pdf`;
                  const response = await fetch(apiUrl, {
                    method: 'GET',
                  });
                  if (!response.ok) throw new Error('PDF download failed');
                  const blob = await response.blob();
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = '転ナビ 利用規約.pdf';
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                } catch (err) {
                  alert('PDFのダウンロードに失敗しました。');
                }
              }}
            >
              ダウンロード
            </Button>
            <IconButton
              onClick={handleCloseTerms}
              sx={{
                ml: 1,
                backgroundColor: '#fff',
                '&:hover': { backgroundColor: '#f0f0f0' },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box id="terms-modal-content-agent" sx={{ pt: 3, px: 3, pb: 3 }}>
            <Terms />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AgentApprovalPendingModal;